<template>
<div>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :page="tablePage"
    :footer-props="{'items-per-page-options': [5,10, 100]}"
    :search="search"
    :hide-default-header="true"
    no-results-text="查無符合資料"
    class="elevation-1"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
          >
            <span>{{ header.text }}</span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="delaySearch"
          @input="onDelaySearchInput"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>

        <!-- <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn> -->
        <v-btn
          v-if="myLevel==10"
          color="primary"
          dark
          class="ml-1 mr-1"
          @click.stop="isShowDialog = true;editingId=-1"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <work-order-list-item
        :item="item"
        :key="`item-${item.ID}`"
        @edit="showEditDialog"
        @remove="deleteItem"
      />
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>


        <work-order-addedit-dialog
          v-if="canEditWorkOrder"
          v-model="isShowDialog"
          :editing-id="editingId"
          @updated="onDataUpdated"
        />

        <v-snackbar
          v-model="isDataRefetched"
          :timeout="-1"
        >
          偵測到資料已更新
          <v-btn
            class="ml-1 mr-1"
            color="pink"
            text
            @click="isDataRefetched = false"
          >
            關閉
          </v-btn>
          <v-btn
            class="ml-1 mr-1"
            color="white"
            text
            @click="reloadDataTable"
          >
            重新載入
          </v-btn>
        </v-snackbar>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import WorkOrderAddeditDialog from "@/ui/work-order/work-order-addedit-dialog.vue";
import WorkOrderListItem from "./work-order-list-item.vue";
import XMLGenerator from "@/data/excel/xml-generator-work-order.js";
import XLSXSaver from "@/data/excel/xlsx-saver.js";

import mixinDelaySearch from "@/ui/mixin-datatable-delaysearch.vue";
export default {
  mixins: [mixinDelaySearch],
  components: {
    WorkOrderAddeditDialog,
    WorkOrderListItem
  },
  data: () => ({
    isLoading: false,
    // data table
    dataTable: [],
    pageTitle: "工單系統",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    tablePage: 1,
    search: "",
    // addedit
    isShowDialog: false,
    editingId: -1,
    // data refetched
    isDataRefetched: false
  }),
  computed: {
    headers() {
      let actionHeader = {
        text: "操作",
        value: "action",
        showInMobile: true
      };
      return [
        {
          text: "工單",
          value: "-",
          showInMobile: true
        },
        {
          text: "工作日期",
          value: "-",
          showInMobile: true
        },
        { text: "狀態", value: "Status", showInMobile: true }
      ].concat([actionHeader]);
    },
    ...mapGetters(["myLevel", "countries", "canEditWorkOrder"])
  },
  methods: {
    exportExcel() {
      let datas = this.dataTable.filter(
        o => !this.search || o.Name.includes(this.search)
      );
      let result = XMLGenerator.generate(this, datas);
      

      var fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        "傳動ERP-工單-匯出"
      );
      if (!fileName) {
        window.alert("請輸入檔案名稱");
        return;
      }
      XLSXSaver.saveAs(result, fileName);
    },
    showEditDialog(itemID) {
      this.editingId = itemID;
      this.isShowDialog = true;
    },
    deleteItem(item) {
      const removingIdx = this.$store.state.workOrder.list.indexOf(item);

      this.isLoading = true;
      this.$services.workOrder
        .inActivate(this, item.ID)
        .then(res => {
          this.$store.state.workOrder.list[removingIdx].IsActive = false;
          // this.$alertMessage("成功刪除工單「" + item.Name + "」!");
          this.reloadDataTable();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reloadDataTable() {
      this.dataTable = this.$store.state.workOrder.list.filter(o => o.IsActive);
      this.isDataRefetched = false;
      this.$store.state.workOrder.isReloaded = false;
      this.tablePage = 1
    },
    onDataUpdated(item) {
      let action = this.editingId >= 0 ? "編輯" : "新增";
      // this.$alertMessage("成功" + action + "工單「" + item.Content + "」!");
      this.reloadDataTable();
    }
  },
  created() {
    if (this.myLevel == 100) {
      alert("沒有權限");
      this.$router.push({ name: "main" });
      return;
    }
    this.isLoading = true;
    this.$services.prepareDatas(this).then(() => {
      this.$services.department
        .prepareData(this)
        .then(this.reloadDataTable)
        .finally(() => {
          this.isLoading = false;
        });
    });
  },
  watch: {
    "$store.state.workOrder.isReloaded"() {
      if (
        this.$store.state.workOrder.isFetched &&
        this.$store.state.workOrder.isReloaded
      )
        this.isDataRefetched = true;
    }, search () {
      this.tablePage = 1
    }
  }
};
</script>